import {Injectable} from '@angular/core';
import {Storage} from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private storageInstance: Storage | null = null;

  constructor(private storage: Storage) {
    this.init().then(r => r);
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this.storageInstance = await this.storage.create();
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public async set(key: string, value: any, merge = false) {
    if (merge) {
      const data = await this.storage.get(key);
      await this.storageInstance?.set(key, {...data, ...value});
    } else {
      await this.storageInstance?.set(key, value);
    }
  }

  public async get(key: string) {
    return await this.storage.get(key);
  }

  public async clear() {
    return await this.storage.clear();
  }

  public async remove(key: string) {
    return await this.storage.remove(key);
  }
}
